import { PaymentCardType } from '@mews/enums';
import { Typography } from '@optimus-web/core';
import { SurchargePercentLabel } from '../../../../../payment/components/forms/legacy/SurchargePercentLabel';

interface SecondaryTextProps {
    enterpriseId: string;
    paymentCardType: PaymentCardType;
}

export const SecondaryText: React.FC<SecondaryTextProps> = ({ enterpriseId, paymentCardType }) => (
    <Typography textStyle="bodySmall" as="div">
        <SurchargePercentLabel enterpriseId={enterpriseId} paymentCardType={paymentCardType} />
    </Typography>
);
